import * as types from './mutation-types'
import facilitiesService from '../../services/facilities'
import { createServiceCall } from '../actionsUtil'

export const getUserFacilities = createServiceCall({
  mainAction: types.GET_FACILITIES_REQUEST,
  serviceFunction: facilitiesService.getFacilities,
  successAction: types.GET_FACILITIES_SUCCESS,
  successDataProperty: 'facilities',
  failureAction: types.GET_FACILITIES_FAILURE
})

export const requestAccessToFacility = createServiceCall({
  mainAction: types.REQUEST_ACCESS_REQUEST,
  serviceFunction: facilitiesService.requestAccessToFacility,
  successAction: types.GET_FACILITIES_SUCCESS,
  successDataProperty: 'facilities',
  failureAction: types.REQUEST_ACCESS_FAILURE
})

export const getFacilityById = createServiceCall({
  mainAction: types.GET_FACILITY_BY_ID_REQUEST,
  serviceFunction: facilitiesService.getFacilityById,
  successAction: types.GET_FACILITY_BY_ID_SUCCESS,
  failureAction: types.GET_FACILITY_BY_ID_FAILURE
})

export const getUserForFacility = createServiceCall({
  mainAction: types.GET_USERS_FOR_FACILITY_REQUEST,
  serviceFunction: facilitiesService.getUserForFacility,
  successAction: types.GET_USERS_FOR_FACILITY_SUCCESS,
  failureAction: types.GET_USERS_FOR_FACILITY_FAILURE
})

export const getActiveFacilities = createServiceCall({
  mainAction: types.GET_ACTIVE_FACILITIES_REQUEST,
  serviceFunction: facilitiesService.getActiveFacilities,
  //successDataProperty: 'facilities',
  successAction: types.GET_ACTIVE_FACILITIES_SUCCESS,
  failureAction: types.GET_ACTIVE_FACILITIES_FAILURE
})

export const getFacilityData = createServiceCall({
  mainAction: types.GET_FACILITY_DATA_REQUEST,
  serviceFunction: facilitiesService.getFacilityData,
  //successDataProperty: 'facilities',
  successAction: types.GET_FACILITY_DATA_SUCCESS,
  failureAction: types.GET_FACILITY_DATA_FAILURE
})

export const getNavigationMenus = createServiceCall({
  mainAction: types.GET_NAVIGATION_MENUS_REQUEST,
  serviceFunction: facilitiesService.getNavigationMenus,
  successAction: types.GET_NAVIGATION_MENUS_SUCCESS,
  failureAction: types.GET_NAVIGATION_MENUS_FAILURE
});